import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=0d7e8d08&scoped=true"
import script from "./Diamond.vue?vue&type=script&lang=js"
export * from "./Diamond.vue?vue&type=script&lang=js"
import style0 from "./Diamond.vue?vue&type=style&index=0&id=0d7e8d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7e8d08",
  null
  
)

export default component.exports